export const hierarchyNamingStyleOptions = [
	{ id: "display_name", name: "Display name" },
	{ id: "base_name", name: "Base name" },
	{ id: "both", name: "Base name and display name" },
] as const;